"use strict";
/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * gomedia/pis/v1/pisservice.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var url = require("url");
var portableFetch = require("portable-fetch");
var BASE_PATH = "http://localhost".replace(/\/+$/, "");
/**
 *
 * @export
 */
exports.COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
/**
 *
 * @export
 * @class BaseAPI
 */
var BaseAPI = /** @class */ (function () {
    function BaseAPI(configuration, basePath, fetch) {
        if (basePath === void 0) { basePath = BASE_PATH; }
        if (fetch === void 0) { fetch = portableFetch; }
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
    return BaseAPI;
}());
exports.BaseAPI = BaseAPI;
;
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
var RequiredError = /** @class */ (function (_super) {
    __extends(RequiredError, _super);
    function RequiredError(field, msg) {
        var _this = _super.call(this, msg) || this;
        _this.field = field;
        _this.name = "RequiredError";
        return _this;
    }
    return RequiredError;
}(Error));
exports.RequiredError = RequiredError;
/**
 *
 * @export
 * @enum {string}
 */
var CallingPointType;
(function (CallingPointType) {
    CallingPointType["CALLINGPOINTTYPEUNSPECIFIED"] = "CALLING_POINT_TYPE_UNSPECIFIED";
    CallingPointType["INTERMEDIATE"] = "INTERMEDIATE";
    CallingPointType["ORIGIN"] = "ORIGIN";
    CallingPointType["DESTINATION"] = "DESTINATION";
})(CallingPointType = exports.CallingPointType || (exports.CallingPointType = {}));
/**
 * - JOURNEY_PHASE_UNSPECIFIED: The first value represents the default and must be == 0
 * @export
 * @enum {string}
 */
var JourneyPhase;
(function (JourneyPhase) {
    JourneyPhase["JOURNEYPHASEUNSPECIFIED"] = "JOURNEY_PHASE_UNSPECIFIED";
    JourneyPhase["PASSED"] = "PASSED";
    JourneyPhase["CURRENT"] = "CURRENT";
    JourneyPhase["UPCOMING"] = "UPCOMING";
    JourneyPhase["PASSEDINFERRED"] = "PASSED_INFERRED";
})(JourneyPhase = exports.JourneyPhase || (exports.JourneyPhase = {}));
/**
 * - MARKET_UNSPECIFIED: The first value represents the default and must be == 0
 * @export
 * @enum {string}
 */
var Market;
(function (Market) {
    Market["MARKETUNSPECIFIED"] = "MARKET_UNSPECIFIED";
    Market["UK"] = "UK";
    Market["CH"] = "CH";
    Market["US"] = "US";
})(Market = exports.Market || (exports.Market = {}));
/**
 * AnnouncementWebServiceApi - fetch parameter creator
 * @export
 */
exports.AnnouncementWebServiceApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [toc]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnouncements: function (toc, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/services/announcements/v1/announcement";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (toc !== undefined) {
                localVarQueryParameter['toc'] = toc;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AnnouncementWebServiceApi - functional programming interface
 * @export
 */
exports.AnnouncementWebServiceApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [toc]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnouncements: function (toc, options) {
            var localVarFetchArgs = exports.AnnouncementWebServiceApiFetchParamCreator(configuration).getAnnouncements(toc, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * AnnouncementWebServiceApi - factory interface
 * @export
 */
exports.AnnouncementWebServiceApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [toc]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnnouncements: function (toc, options) {
            return exports.AnnouncementWebServiceApiFp(configuration).getAnnouncements(toc, options)(fetch, basePath);
        },
    };
};
/**
 * AnnouncementWebServiceApi - object-oriented interface
 * @export
 * @class AnnouncementWebServiceApi
 * @extends {BaseAPI}
 */
var AnnouncementWebServiceApi = /** @class */ (function (_super) {
    __extends(AnnouncementWebServiceApi, _super);
    function AnnouncementWebServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Auth is used to obtain JWT token, which should be used for Subscribe
     * @param {string} [toc]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnnouncementWebServiceApi
     */
    AnnouncementWebServiceApi.prototype.getAnnouncements = function (toc, options) {
        return exports.AnnouncementWebServiceApiFp(this.configuration).getAnnouncements(toc, options)(this.fetch, this.basePath);
    };
    return AnnouncementWebServiceApi;
}(BaseAPI));
exports.AnnouncementWebServiceApi = AnnouncementWebServiceApi;
/**
 * ApiServiceApi - fetch parameter creator
 * @export
 */
exports.ApiServiceApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [api_key]
         * @param {string} [api_secret]
         * @param {string} [rid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShareMyTrainLink: function (api_key, api_secret, rid, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/services/api/v1/share/link";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (api_key !== undefined) {
                localVarQueryParameter['api_key'] = api_key;
            }
            if (api_secret !== undefined) {
                localVarQueryParameter['api_secret'] = api_secret;
            }
            if (rid !== undefined) {
                localVarQueryParameter['rid'] = rid;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [token]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareMyTrainJourney: function (token, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/services/api/v1/share/journey";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ApiServiceApi - functional programming interface
 * @export
 */
exports.ApiServiceApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [api_key]
         * @param {string} [api_secret]
         * @param {string} [rid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShareMyTrainLink: function (api_key, api_secret, rid, options) {
            var localVarFetchArgs = exports.ApiServiceApiFetchParamCreator(configuration).createShareMyTrainLink(api_key, api_secret, rid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [token]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareMyTrainJourney: function (token, options) {
            var localVarFetchArgs = exports.ApiServiceApiFetchParamCreator(configuration).getShareMyTrainJourney(token, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * ApiServiceApi - factory interface
 * @export
 */
exports.ApiServiceApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [api_key]
         * @param {string} [api_secret]
         * @param {string} [rid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShareMyTrainLink: function (api_key, api_secret, rid, options) {
            return exports.ApiServiceApiFp(configuration).createShareMyTrainLink(api_key, api_secret, rid, options)(fetch, basePath);
        },
        /**
         *
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [token]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareMyTrainJourney: function (token, options) {
            return exports.ApiServiceApiFp(configuration).getShareMyTrainJourney(token, options)(fetch, basePath);
        },
    };
};
/**
 * ApiServiceApi - object-oriented interface
 * @export
 * @class ApiServiceApi
 * @extends {BaseAPI}
 */
var ApiServiceApi = /** @class */ (function (_super) {
    __extends(ApiServiceApi, _super);
    function ApiServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Auth is used to obtain JWT token, which should be used for Subscribe
     * @param {string} [api_key]
     * @param {string} [api_secret]
     * @param {string} [rid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiServiceApi
     */
    ApiServiceApi.prototype.createShareMyTrainLink = function (api_key, api_secret, rid, options) {
        return exports.ApiServiceApiFp(this.configuration).createShareMyTrainLink(api_key, api_secret, rid, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
     * @param {string} [token]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiServiceApi
     */
    ApiServiceApi.prototype.getShareMyTrainJourney = function (token, options) {
        return exports.ApiServiceApiFp(this.configuration).getShareMyTrainJourney(token, options)(this.fetch, this.basePath);
    };
    return ApiServiceApi;
}(BaseAPI));
exports.ApiServiceApi = ApiServiceApi;
/**
 * DeparturesServiceApi - fetch parameter creator
 * @export
 */
exports.DeparturesServiceApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [calling_point_id_type] type specifies the type of the id, for example it can be way to address stations in particular market.
         * @param {string} [calling_point_id_id] id specifies the id of the entity.
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US'} [calling_point_id_market] market defines the market this id belongs to.   - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {Date} [time_from]
         * @param {Date} [time_to]
         * @param {string} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartures: function (calling_point_id_type, calling_point_id_id, calling_point_id_market, time_from, time_to, limit, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/services/departures/v1";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (calling_point_id_type !== undefined) {
                localVarQueryParameter['calling_point_id.type'] = calling_point_id_type;
            }
            if (calling_point_id_id !== undefined) {
                localVarQueryParameter['calling_point_id.id'] = calling_point_id_id;
            }
            if (calling_point_id_market !== undefined) {
                localVarQueryParameter['calling_point_id.market'] = calling_point_id_market;
            }
            if (time_from !== undefined) {
                localVarQueryParameter['time_from'] = time_from.toISOString();
            }
            if (time_to !== undefined) {
                localVarQueryParameter['time_to'] = time_to.toISOString();
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DeparturesServiceApi - functional programming interface
 * @export
 */
exports.DeparturesServiceApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [calling_point_id_type] type specifies the type of the id, for example it can be way to address stations in particular market.
         * @param {string} [calling_point_id_id] id specifies the id of the entity.
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US'} [calling_point_id_market] market defines the market this id belongs to.   - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {Date} [time_from]
         * @param {Date} [time_to]
         * @param {string} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartures: function (calling_point_id_type, calling_point_id_id, calling_point_id_market, time_from, time_to, limit, options) {
            var localVarFetchArgs = exports.DeparturesServiceApiFetchParamCreator(configuration).getDepartures(calling_point_id_type, calling_point_id_id, calling_point_id_market, time_from, time_to, limit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * DeparturesServiceApi - factory interface
 * @export
 */
exports.DeparturesServiceApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [calling_point_id_type] type specifies the type of the id, for example it can be way to address stations in particular market.
         * @param {string} [calling_point_id_id] id specifies the id of the entity.
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US'} [calling_point_id_market] market defines the market this id belongs to.   - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {Date} [time_from]
         * @param {Date} [time_to]
         * @param {string} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepartures: function (calling_point_id_type, calling_point_id_id, calling_point_id_market, time_from, time_to, limit, options) {
            return exports.DeparturesServiceApiFp(configuration).getDepartures(calling_point_id_type, calling_point_id_id, calling_point_id_market, time_from, time_to, limit, options)(fetch, basePath);
        },
    };
};
/**
 * DeparturesServiceApi - object-oriented interface
 * @export
 * @class DeparturesServiceApi
 * @extends {BaseAPI}
 */
var DeparturesServiceApi = /** @class */ (function (_super) {
    __extends(DeparturesServiceApi, _super);
    function DeparturesServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Auth is used to obtain JWT token, which should be used for Subscribe
     * @param {string} [calling_point_id_type] type specifies the type of the id, for example it can be way to address stations in particular market.
     * @param {string} [calling_point_id_id] id specifies the id of the entity.
     * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US'} [calling_point_id_market] market defines the market this id belongs to.   - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
     * @param {Date} [time_from]
     * @param {Date} [time_to]
     * @param {string} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeparturesServiceApi
     */
    DeparturesServiceApi.prototype.getDepartures = function (calling_point_id_type, calling_point_id_id, calling_point_id_market, time_from, time_to, limit, options) {
        return exports.DeparturesServiceApiFp(this.configuration).getDepartures(calling_point_id_type, calling_point_id_id, calling_point_id_market, time_from, time_to, limit, options)(this.fetch, this.basePath);
    };
    return DeparturesServiceApi;
}(BaseAPI));
exports.DeparturesServiceApi = DeparturesServiceApi;
/**
 * EngineWebServiceApi - fetch parameter creator
 * @export
 */
exports.EngineWebServiceApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignedJourneys: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/services/engine/v1/assigned-journeys";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectedVehicles: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/services/engine/v1/connected-vehicles";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US'} market
         * @param {string} journey_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourney: function (market, journey_id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'market' is not null or undefined
            if (market === null || market === undefined) {
                throw new RequiredError('market', 'Required parameter market was null or undefined when calling getJourney.');
            }
            // verify required parameter 'journey_id' is not null or undefined
            if (journey_id === null || journey_id === undefined) {
                throw new RequiredError('journey_id', 'Required parameter journey_id was null or undefined when calling getJourney.');
            }
            var localVarPath = "/services/engine/v1/journey/{market}/{journey_id}"
                .replace("{" + "market" + "}", encodeURIComponent(String(market)))
                .replace("{" + "journey_id" + "}", encodeURIComponent(String(journey_id)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EngineWebServiceApi - functional programming interface
 * @export
 */
exports.EngineWebServiceApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignedJourneys: function (options) {
            var localVarFetchArgs = exports.EngineWebServiceApiFetchParamCreator(configuration).getAssignedJourneys(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectedVehicles: function (options) {
            var localVarFetchArgs = exports.EngineWebServiceApiFetchParamCreator(configuration).getConnectedVehicles(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US'} market
         * @param {string} journey_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourney: function (market, journey_id, options) {
            var localVarFetchArgs = exports.EngineWebServiceApiFetchParamCreator(configuration).getJourney(market, journey_id, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * EngineWebServiceApi - factory interface
 * @export
 */
exports.EngineWebServiceApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignedJourneys: function (options) {
            return exports.EngineWebServiceApiFp(configuration).getAssignedJourneys(options)(fetch, basePath);
        },
        /**
         *
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectedVehicles: function (options) {
            return exports.EngineWebServiceApiFp(configuration).getConnectedVehicles(options)(fetch, basePath);
        },
        /**
         *
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US'} market
         * @param {string} journey_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourney: function (market, journey_id, options) {
            return exports.EngineWebServiceApiFp(configuration).getJourney(market, journey_id, options)(fetch, basePath);
        },
    };
};
/**
 * EngineWebServiceApi - object-oriented interface
 * @export
 * @class EngineWebServiceApi
 * @extends {BaseAPI}
 */
var EngineWebServiceApi = /** @class */ (function (_super) {
    __extends(EngineWebServiceApi, _super);
    function EngineWebServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Auth is used to obtain JWT token, which should be used for Subscribe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EngineWebServiceApi
     */
    EngineWebServiceApi.prototype.getAssignedJourneys = function (options) {
        return exports.EngineWebServiceApiFp(this.configuration).getAssignedJourneys(options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EngineWebServiceApi
     */
    EngineWebServiceApi.prototype.getConnectedVehicles = function (options) {
        return exports.EngineWebServiceApiFp(this.configuration).getConnectedVehicles(options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
     * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US'} market
     * @param {string} journey_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EngineWebServiceApi
     */
    EngineWebServiceApi.prototype.getJourney = function (market, journey_id, options) {
        return exports.EngineWebServiceApiFp(this.configuration).getJourney(market, journey_id, options)(this.fetch, this.basePath);
    };
    return EngineWebServiceApi;
}(BaseAPI));
exports.EngineWebServiceApi = EngineWebServiceApi;
/**
 * PisFeedbackServiceApi - fetch parameter creator
 * @export
 */
exports.PisFeedbackServiceApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [page] page represent page number what should be sent from 0 - first page.
         * @param {string} [size] page_size represents size of output array.
         * @param {Date} [from_date] from_date using to search feedbacks from some date.
         * @param {Date} [to_date] to_date using to search feedbacks to some date.
         * @param {string} [query] query using to search feedbacks from some journey text.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedbacks: function (page, size, from_date, to_date, query, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/services/pisfeedbackservice/v1/feedback";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (from_date !== undefined) {
                localVarQueryParameter['from_date'] = from_date.toISOString();
            }
            if (to_date !== undefined) {
                localVarQueryParameter['to_date'] = to_date.toISOString();
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {Feedback} Feedback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFeedback: function (Feedback, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'Feedback' is not null or undefined
            if (Feedback === null || Feedback === undefined) {
                throw new RequiredError('Feedback', 'Required parameter Feedback was null or undefined when calling sendFeedback.');
            }
            var localVarPath = "/services/pisfeedbackservice/v1/feedback";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Feedback" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(Feedback || {}) : (Feedback || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PisFeedbackServiceApi - functional programming interface
 * @export
 */
exports.PisFeedbackServiceApiFp = function (configuration) {
    return {
        /**
         *
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [page] page represent page number what should be sent from 0 - first page.
         * @param {string} [size] page_size represents size of output array.
         * @param {Date} [from_date] from_date using to search feedbacks from some date.
         * @param {Date} [to_date] to_date using to search feedbacks to some date.
         * @param {string} [query] query using to search feedbacks from some journey text.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedbacks: function (page, size, from_date, to_date, query, options) {
            var localVarFetchArgs = exports.PisFeedbackServiceApiFetchParamCreator(configuration).getFeedbacks(page, size, from_date, to_date, query, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {Feedback} Feedback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFeedback: function (Feedback, options) {
            var localVarFetchArgs = exports.PisFeedbackServiceApiFetchParamCreator(configuration).sendFeedback(Feedback, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * PisFeedbackServiceApi - factory interface
 * @export
 */
exports.PisFeedbackServiceApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [page] page represent page number what should be sent from 0 - first page.
         * @param {string} [size] page_size represents size of output array.
         * @param {Date} [from_date] from_date using to search feedbacks from some date.
         * @param {Date} [to_date] to_date using to search feedbacks to some date.
         * @param {string} [query] query using to search feedbacks from some journey text.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedbacks: function (page, size, from_date, to_date, query, options) {
            return exports.PisFeedbackServiceApiFp(configuration).getFeedbacks(page, size, from_date, to_date, query, options)(fetch, basePath);
        },
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {Feedback} Feedback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFeedback: function (Feedback, options) {
            return exports.PisFeedbackServiceApiFp(configuration).sendFeedback(Feedback, options)(fetch, basePath);
        },
    };
};
/**
 * PisFeedbackServiceApi - object-oriented interface
 * @export
 * @class PisFeedbackServiceApi
 * @extends {BaseAPI}
 */
var PisFeedbackServiceApi = /** @class */ (function (_super) {
    __extends(PisFeedbackServiceApi, _super);
    function PisFeedbackServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
     * @param {string} [page] page represent page number what should be sent from 0 - first page.
     * @param {string} [size] page_size represents size of output array.
     * @param {Date} [from_date] from_date using to search feedbacks from some date.
     * @param {Date} [to_date] to_date using to search feedbacks to some date.
     * @param {string} [query] query using to search feedbacks from some journey text.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PisFeedbackServiceApi
     */
    PisFeedbackServiceApi.prototype.getFeedbacks = function (page, size, from_date, to_date, query, options) {
        return exports.PisFeedbackServiceApiFp(this.configuration).getFeedbacks(page, size, from_date, to_date, query, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Auth is used to obtain JWT token, which should be used for Subscribe
     * @param {Feedback} Feedback
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PisFeedbackServiceApi
     */
    PisFeedbackServiceApi.prototype.sendFeedback = function (Feedback, options) {
        return exports.PisFeedbackServiceApiFp(this.configuration).sendFeedback(Feedback, options)(this.fetch, this.basePath);
    };
    return PisFeedbackServiceApi;
}(BaseAPI));
exports.PisFeedbackServiceApi = PisFeedbackServiceApi;
/**
 * RegistryWebServiceApi - fetch parameter creator
 * @export
 */
exports.RegistryWebServiceApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {AddUnknownSubscriberRequest} AddUnknownSubscriberRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUnknownSubscriber: function (AddUnknownSubscriberRequest, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'AddUnknownSubscriberRequest' is not null or undefined
            if (AddUnknownSubscriberRequest === null || AddUnknownSubscriberRequest === undefined) {
                throw new RequiredError('AddUnknownSubscriberRequest', 'Required parameter AddUnknownSubscriberRequest was null or undefined when calling addUnknownSubscriber.');
            }
            var localVarPath = "/services/registry/v1/add-unknown-subscriber";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("AddUnknownSubscriberRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(AddUnknownSubscriberRequest || {}) : (AddUnknownSubscriberRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary CheckShareToken is used to obtain data connected to token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMarkets: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/services/registry/v1/markets";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTocs: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/services/registry/v1/tocs";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [toc]
         * @param {string} [market]
         * @param {string} [subscriber_id]
         * @param {string} [page_size]
         * @param {string} [page_number]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnknownSubscribers: function (toc, market, subscriber_id, page_size, page_number, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/services/registry/v1/unknown-subscribers";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (toc !== undefined) {
                localVarQueryParameter['toc'] = toc;
            }
            if (market !== undefined) {
                localVarQueryParameter['market'] = market;
            }
            if (subscriber_id !== undefined) {
                localVarQueryParameter['subscriber_id'] = subscriber_id;
            }
            if (page_size !== undefined) {
                localVarQueryParameter['page_size'] = page_size;
            }
            if (page_number !== undefined) {
                localVarQueryParameter['page_number'] = page_number;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RegistryWebServiceApi - functional programming interface
 * @export
 */
exports.RegistryWebServiceApiFp = function (configuration) {
    return {
        /**
         *
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {AddUnknownSubscriberRequest} AddUnknownSubscriberRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUnknownSubscriber: function (AddUnknownSubscriberRequest, options) {
            var localVarFetchArgs = exports.RegistryWebServiceApiFetchParamCreator(configuration).addUnknownSubscriber(AddUnknownSubscriberRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary CheckShareToken is used to obtain data connected to token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMarkets: function (options) {
            var localVarFetchArgs = exports.RegistryWebServiceApiFetchParamCreator(configuration).getAllMarkets(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTocs: function (options) {
            var localVarFetchArgs = exports.RegistryWebServiceApiFetchParamCreator(configuration).getAllTocs(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [toc]
         * @param {string} [market]
         * @param {string} [subscriber_id]
         * @param {string} [page_size]
         * @param {string} [page_number]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnknownSubscribers: function (toc, market, subscriber_id, page_size, page_number, options) {
            var localVarFetchArgs = exports.RegistryWebServiceApiFetchParamCreator(configuration).getUnknownSubscribers(toc, market, subscriber_id, page_size, page_number, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * RegistryWebServiceApi - factory interface
 * @export
 */
exports.RegistryWebServiceApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {AddUnknownSubscriberRequest} AddUnknownSubscriberRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUnknownSubscriber: function (AddUnknownSubscriberRequest, options) {
            return exports.RegistryWebServiceApiFp(configuration).addUnknownSubscriber(AddUnknownSubscriberRequest, options)(fetch, basePath);
        },
        /**
         *
         * @summary CheckShareToken is used to obtain data connected to token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMarkets: function (options) {
            return exports.RegistryWebServiceApiFp(configuration).getAllMarkets(options)(fetch, basePath);
        },
        /**
         *
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTocs: function (options) {
            return exports.RegistryWebServiceApiFp(configuration).getAllTocs(options)(fetch, basePath);
        },
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [toc]
         * @param {string} [market]
         * @param {string} [subscriber_id]
         * @param {string} [page_size]
         * @param {string} [page_number]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnknownSubscribers: function (toc, market, subscriber_id, page_size, page_number, options) {
            return exports.RegistryWebServiceApiFp(configuration).getUnknownSubscribers(toc, market, subscriber_id, page_size, page_number, options)(fetch, basePath);
        },
    };
};
/**
 * RegistryWebServiceApi - object-oriented interface
 * @export
 * @class RegistryWebServiceApi
 * @extends {BaseAPI}
 */
var RegistryWebServiceApi = /** @class */ (function (_super) {
    __extends(RegistryWebServiceApi, _super);
    function RegistryWebServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
     * @param {AddUnknownSubscriberRequest} AddUnknownSubscriberRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistryWebServiceApi
     */
    RegistryWebServiceApi.prototype.addUnknownSubscriber = function (AddUnknownSubscriberRequest, options) {
        return exports.RegistryWebServiceApiFp(this.configuration).addUnknownSubscriber(AddUnknownSubscriberRequest, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary CheckShareToken is used to obtain data connected to token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistryWebServiceApi
     */
    RegistryWebServiceApi.prototype.getAllMarkets = function (options) {
        return exports.RegistryWebServiceApiFp(this.configuration).getAllMarkets(options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistryWebServiceApi
     */
    RegistryWebServiceApi.prototype.getAllTocs = function (options) {
        return exports.RegistryWebServiceApiFp(this.configuration).getAllTocs(options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Auth is used to obtain JWT token, which should be used for Subscribe
     * @param {string} [toc]
     * @param {string} [market]
     * @param {string} [subscriber_id]
     * @param {string} [page_size]
     * @param {string} [page_number]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistryWebServiceApi
     */
    RegistryWebServiceApi.prototype.getUnknownSubscribers = function (toc, market, subscriber_id, page_size, page_number, options) {
        return exports.RegistryWebServiceApiFp(this.configuration).getUnknownSubscribers(toc, market, subscriber_id, page_size, page_number, options)(this.fetch, this.basePath);
    };
    return RegistryWebServiceApi;
}(BaseAPI));
exports.RegistryWebServiceApi = RegistryWebServiceApi;
/**
 * TelemetryWebServiceApi - fetch parameter creator
 * @export
 */
exports.TelemetryWebServiceApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [market]
         * @param {string} [subscriber_id]
         * @param {string} [journey_id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailedJourney: function (market, subscriber_id, journey_id, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/services/telemetry/v1/failed-journey";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (market !== undefined) {
                localVarQueryParameter['market'] = market;
            }
            if (subscriber_id !== undefined) {
                localVarQueryParameter['subscriber_id'] = subscriber_id;
            }
            if (journey_id !== undefined) {
                localVarQueryParameter['journey_id'] = journey_id;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [page] page represent page number what should be sent from 1 - first page.
         * @param {string} [size] page_size represents size of output array.
         * @param {string} [market] filters.
         * @param {string} [subscriber_id]
         * @param {string} [journey_id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailedJourneys: function (page, size, market, subscriber_id, journey_id, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/services/telemetry/v1/failed-journeys";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (market !== undefined) {
                localVarQueryParameter['market'] = market;
            }
            if (subscriber_id !== undefined) {
                localVarQueryParameter['subscriber_id'] = subscriber_id;
            }
            if (journey_id !== undefined) {
                localVarQueryParameter['journey_id'] = journey_id;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TelemetryWebServiceApi - functional programming interface
 * @export
 */
exports.TelemetryWebServiceApiFp = function (configuration) {
    return {
        /**
         *
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [market]
         * @param {string} [subscriber_id]
         * @param {string} [journey_id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailedJourney: function (market, subscriber_id, journey_id, options) {
            var localVarFetchArgs = exports.TelemetryWebServiceApiFetchParamCreator(configuration).getFailedJourney(market, subscriber_id, journey_id, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [page] page represent page number what should be sent from 1 - first page.
         * @param {string} [size] page_size represents size of output array.
         * @param {string} [market] filters.
         * @param {string} [subscriber_id]
         * @param {string} [journey_id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailedJourneys: function (page, size, market, subscriber_id, journey_id, options) {
            var localVarFetchArgs = exports.TelemetryWebServiceApiFetchParamCreator(configuration).getFailedJourneys(page, size, market, subscriber_id, journey_id, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * TelemetryWebServiceApi - factory interface
 * @export
 */
exports.TelemetryWebServiceApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [market]
         * @param {string} [subscriber_id]
         * @param {string} [journey_id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailedJourney: function (market, subscriber_id, journey_id, options) {
            return exports.TelemetryWebServiceApiFp(configuration).getFailedJourney(market, subscriber_id, journey_id, options)(fetch, basePath);
        },
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} [page] page represent page number what should be sent from 1 - first page.
         * @param {string} [size] page_size represents size of output array.
         * @param {string} [market] filters.
         * @param {string} [subscriber_id]
         * @param {string} [journey_id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailedJourneys: function (page, size, market, subscriber_id, journey_id, options) {
            return exports.TelemetryWebServiceApiFp(configuration).getFailedJourneys(page, size, market, subscriber_id, journey_id, options)(fetch, basePath);
        },
    };
};
/**
 * TelemetryWebServiceApi - object-oriented interface
 * @export
 * @class TelemetryWebServiceApi
 * @extends {BaseAPI}
 */
var TelemetryWebServiceApi = /** @class */ (function (_super) {
    __extends(TelemetryWebServiceApi, _super);
    function TelemetryWebServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
     * @param {string} [market]
     * @param {string} [subscriber_id]
     * @param {string} [journey_id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TelemetryWebServiceApi
     */
    TelemetryWebServiceApi.prototype.getFailedJourney = function (market, subscriber_id, journey_id, options) {
        return exports.TelemetryWebServiceApiFp(this.configuration).getFailedJourney(market, subscriber_id, journey_id, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Auth is used to obtain JWT token, which should be used for Subscribe
     * @param {string} [page] page represent page number what should be sent from 1 - first page.
     * @param {string} [size] page_size represents size of output array.
     * @param {string} [market] filters.
     * @param {string} [subscriber_id]
     * @param {string} [journey_id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TelemetryWebServiceApi
     */
    TelemetryWebServiceApi.prototype.getFailedJourneys = function (page, size, market, subscriber_id, journey_id, options) {
        return exports.TelemetryWebServiceApiFp(this.configuration).getFailedJourneys(page, size, market, subscriber_id, journey_id, options)(this.fetch, this.basePath);
    };
    return TelemetryWebServiceApi;
}(BaseAPI));
exports.TelemetryWebServiceApi = TelemetryWebServiceApi;
/**
 * VehiclePisServiceApi - fetch parameter creator
 * @export
 */
exports.VehiclePisServiceApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {string} calling_point_id_id id specifies the id of the entity
         * @param {string} [calling_point_id_type] type specifies the type of the id, for example it can be way to address stations in particular market.
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US'} [calling_point_id_market] market defines the market this id belongs to.   - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDepartures: function (calling_point_id_id, calling_point_id_type, calling_point_id_market, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'calling_point_id_id' is not null or undefined
            if (calling_point_id_id === null || calling_point_id_id === undefined) {
                throw new RequiredError('calling_point_id_id', 'Required parameter calling_point_id_id was null or undefined when calling getAllDepartures.');
            }
            var localVarPath = "/services/pis/v1/journey/departures/{calling_point_id.id}"
                .replace("{" + "calling_point_id.id" + "}", encodeURIComponent(String(calling_point_id_id)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (calling_point_id_type !== undefined) {
                localVarQueryParameter['calling_point_id.type'] = calling_point_id_type;
            }
            if (calling_point_id_market !== undefined) {
                localVarQueryParameter['calling_point_id.market'] = calling_point_id_market;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary GetCurrentRoute returns current route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentRoute: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/services/pis/v1/journey/route";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} subscriber_name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourney: function (subscriber_name, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'subscriber_name' is not null or undefined
            if (subscriber_name === null || subscriber_name === undefined) {
                throw new RequiredError('subscriber_name', 'Required parameter subscriber_name was null or undefined when calling getJourney.');
            }
            var localVarPath = "/services/pis/v1/subscriber/{subscriber.name}/journey"
                .replace("{" + "subscriber.name" + "}", encodeURIComponent(String(subscriber_name)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary GetJourneyStations returns stations with coordinates on route for map
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourneyStations: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/services/pis/v1/journey/stations";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary CheckShareToken is used to obtain data connected to token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosition: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/services/pis/v1/position";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [subscriber_name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimpleJourney: function (subscriber_name, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/services/pis/v1/journey";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (subscriber_name !== undefined) {
                localVarQueryParameter['subscriber.name'] = subscriber_name;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary GetSharedJourney requests the journey by token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriber: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/services/pis/v1/subscriber";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary GetVehicleInfo returns vehicle info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleInfo: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/services/pis/v1/vehicle";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary GetActiveSubscriber returns any active journey for company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareMyTrain: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/services/pis/v1/share-my-train";
            var localVarUrlObj = url.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = Object.assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * VehiclePisServiceApi - functional programming interface
 * @export
 */
exports.VehiclePisServiceApiFp = function (configuration) {
    return {
        /**
         *
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {string} calling_point_id_id id specifies the id of the entity
         * @param {string} [calling_point_id_type] type specifies the type of the id, for example it can be way to address stations in particular market.
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US'} [calling_point_id_market] market defines the market this id belongs to.   - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDepartures: function (calling_point_id_id, calling_point_id_type, calling_point_id_market, options) {
            var localVarFetchArgs = exports.VehiclePisServiceApiFetchParamCreator(configuration).getAllDepartures(calling_point_id_id, calling_point_id_type, calling_point_id_market, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary GetCurrentRoute returns current route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentRoute: function (options) {
            var localVarFetchArgs = exports.VehiclePisServiceApiFetchParamCreator(configuration).getCurrentRoute(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} subscriber_name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourney: function (subscriber_name, options) {
            var localVarFetchArgs = exports.VehiclePisServiceApiFetchParamCreator(configuration).getJourney(subscriber_name, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary GetJourneyStations returns stations with coordinates on route for map
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourneyStations: function (options) {
            var localVarFetchArgs = exports.VehiclePisServiceApiFetchParamCreator(configuration).getJourneyStations(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary CheckShareToken is used to obtain data connected to token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosition: function (options) {
            var localVarFetchArgs = exports.VehiclePisServiceApiFetchParamCreator(configuration).getPosition(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [subscriber_name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimpleJourney: function (subscriber_name, options) {
            var localVarFetchArgs = exports.VehiclePisServiceApiFetchParamCreator(configuration).getSimpleJourney(subscriber_name, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary GetSharedJourney requests the journey by token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriber: function (options) {
            var localVarFetchArgs = exports.VehiclePisServiceApiFetchParamCreator(configuration).getSubscriber(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary GetVehicleInfo returns vehicle info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleInfo: function (options) {
            var localVarFetchArgs = exports.VehiclePisServiceApiFetchParamCreator(configuration).getVehicleInfo(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary GetActiveSubscriber returns any active journey for company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareMyTrain: function (options) {
            var localVarFetchArgs = exports.VehiclePisServiceApiFetchParamCreator(configuration).shareMyTrain(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * VehiclePisServiceApi - factory interface
 * @export
 */
exports.VehiclePisServiceApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
         * @param {string} calling_point_id_id id specifies the id of the entity
         * @param {string} [calling_point_id_type] type specifies the type of the id, for example it can be way to address stations in particular market.
         * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US'} [calling_point_id_market] market defines the market this id belongs to.   - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDepartures: function (calling_point_id_id, calling_point_id_type, calling_point_id_market, options) {
            return exports.VehiclePisServiceApiFp(configuration).getAllDepartures(calling_point_id_id, calling_point_id_type, calling_point_id_market, options)(fetch, basePath);
        },
        /**
         *
         * @summary GetCurrentRoute returns current route
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentRoute: function (options) {
            return exports.VehiclePisServiceApiFp(configuration).getCurrentRoute(options)(fetch, basePath);
        },
        /**
         *
         * @summary Auth is used to obtain JWT token, which should be used for Subscribe
         * @param {string} subscriber_name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourney: function (subscriber_name, options) {
            return exports.VehiclePisServiceApiFp(configuration).getJourney(subscriber_name, options)(fetch, basePath);
        },
        /**
         *
         * @summary GetJourneyStations returns stations with coordinates on route for map
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJourneyStations: function (options) {
            return exports.VehiclePisServiceApiFp(configuration).getJourneyStations(options)(fetch, basePath);
        },
        /**
         *
         * @summary CheckShareToken is used to obtain data connected to token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosition: function (options) {
            return exports.VehiclePisServiceApiFp(configuration).getPosition(options)(fetch, basePath);
        },
        /**
         *
         * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
         * @param {string} [subscriber_name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimpleJourney: function (subscriber_name, options) {
            return exports.VehiclePisServiceApiFp(configuration).getSimpleJourney(subscriber_name, options)(fetch, basePath);
        },
        /**
         *
         * @summary GetSharedJourney requests the journey by token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriber: function (options) {
            return exports.VehiclePisServiceApiFp(configuration).getSubscriber(options)(fetch, basePath);
        },
        /**
         *
         * @summary GetVehicleInfo returns vehicle info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleInfo: function (options) {
            return exports.VehiclePisServiceApiFp(configuration).getVehicleInfo(options)(fetch, basePath);
        },
        /**
         *
         * @summary GetActiveSubscriber returns any active journey for company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareMyTrain: function (options) {
            return exports.VehiclePisServiceApiFp(configuration).shareMyTrain(options)(fetch, basePath);
        },
    };
};
/**
 * VehiclePisServiceApi - object-oriented interface
 * @export
 * @class VehiclePisServiceApi
 * @extends {BaseAPI}
 */
var VehiclePisServiceApi = /** @class */ (function (_super) {
    __extends(VehiclePisServiceApi, _super);
    function VehiclePisServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary GenerateShareToken is used to generate JWT token, which should be used for share journey
     * @param {string} calling_point_id_id id specifies the id of the entity
     * @param {string} [calling_point_id_type] type specifies the type of the id, for example it can be way to address stations in particular market.
     * @param {'MARKET_UNSPECIFIED' | 'UK' | 'CH' | 'US'} [calling_point_id_market] market defines the market this id belongs to.   - MARKET_UNSPECIFIED: The first value represents the default and must be &#x3D;&#x3D; 0
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePisServiceApi
     */
    VehiclePisServiceApi.prototype.getAllDepartures = function (calling_point_id_id, calling_point_id_type, calling_point_id_market, options) {
        return exports.VehiclePisServiceApiFp(this.configuration).getAllDepartures(calling_point_id_id, calling_point_id_type, calling_point_id_market, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary GetCurrentRoute returns current route
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePisServiceApi
     */
    VehiclePisServiceApi.prototype.getCurrentRoute = function (options) {
        return exports.VehiclePisServiceApiFp(this.configuration).getCurrentRoute(options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary Auth is used to obtain JWT token, which should be used for Subscribe
     * @param {string} subscriber_name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePisServiceApi
     */
    VehiclePisServiceApi.prototype.getJourney = function (subscriber_name, options) {
        return exports.VehiclePisServiceApiFp(this.configuration).getJourney(subscriber_name, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary GetJourneyStations returns stations with coordinates on route for map
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePisServiceApi
     */
    VehiclePisServiceApi.prototype.getJourneyStations = function (options) {
        return exports.VehiclePisServiceApiFp(this.configuration).getJourneyStations(options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary CheckShareToken is used to obtain data connected to token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePisServiceApi
     */
    VehiclePisServiceApi.prototype.getPosition = function (options) {
        return exports.VehiclePisServiceApiFp(this.configuration).getPosition(options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary GetMyJourney requests the currently assigned journey for a specific PisSubscriber. Currently assigned journey would be sent and any subsequent updates as they happen.
     * @param {string} [subscriber_name]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePisServiceApi
     */
    VehiclePisServiceApi.prototype.getSimpleJourney = function (subscriber_name, options) {
        return exports.VehiclePisServiceApiFp(this.configuration).getSimpleJourney(subscriber_name, options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary GetSharedJourney requests the journey by token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePisServiceApi
     */
    VehiclePisServiceApi.prototype.getSubscriber = function (options) {
        return exports.VehiclePisServiceApiFp(this.configuration).getSubscriber(options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary GetVehicleInfo returns vehicle info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePisServiceApi
     */
    VehiclePisServiceApi.prototype.getVehicleInfo = function (options) {
        return exports.VehiclePisServiceApiFp(this.configuration).getVehicleInfo(options)(this.fetch, this.basePath);
    };
    /**
     *
     * @summary GetActiveSubscriber returns any active journey for company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclePisServiceApi
     */
    VehiclePisServiceApi.prototype.shareMyTrain = function (options) {
        return exports.VehiclePisServiceApiFp(this.configuration).shareMyTrain(options)(this.fetch, this.basePath);
    };
    return VehiclePisServiceApi;
}(BaseAPI));
exports.VehiclePisServiceApi = VehiclePisServiceApi;
